import ColorInput from './ColorInput';

export default ColorInput;



// WEBPACK FOOTER //
// ./src/shared/components/ColorInput/index.js